import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const AccessibilityContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 30px;
    background-color: ${(props) => props.theme.white};
    border-bottom: 1px solid ${(props) => props.theme.borderLightGrey};
    padding: 0 24px 0 0;
`;

export const LineSeparator = styled.div`
    width: 100%;
    height: 30px;
    border-right: 1px solid ${(props) => props.theme.borderLightGrey};
`;

export const AlignIcons = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    cursor: pointer;
`;

export const AcessibilityFont = styled.div`
  font-size: ${theme.font.size14};
  color: ${(props) => props.theme.greyLink};
  font-weight: bold;
`;

export const AlignConstrastBtn = styled.div`
    display: flex;
`;
